<template>
    <div class="te-time-slot-selector">
        <div class="te-cart-heading">{{languageSettings.selectTimeSlot}}</div>
        <div class="te-time-slot-list">
            <div v-for="timeSlot in timeSlots"
                 :key="timeSlot.capacityLocationPath"
                 class="te-time-slot"
                 @click="selectTimeSlot(timeSlot)"
            >
<!--              {{formattedTime(timeSlot.start)}}-->
              {{timeSlot.name}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import moment from "moment";

    export default {
        name: "TimeSlotSelector",

        props: {
            language: {
                type: Object
            },
        },

        computed: {
            ...mapGetters({
                event: 'event',
            }),

            timeSlots: function () {
                if(this.event && this.event.capacityLocationSummery && Array.isArray(this.event.capacityLocationSummery)) {
                    return this.event.capacityLocationSummery.filter(c => c.available !== undefined && c.available !== null && c.available > 0);
                }
                return [];
            },

            languageSettings: function() {
                const defaultSettings = {
                    selectTimeSlot: 'Select a time slot',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            selectTimeSlot(timeslot) {
                if(timeslot.available > 0) {
                    this.$emit('select', timeslot.capacityLocationPath);
                }
            },

            formattedTime(dateTimeString) {
                return moment(dateTimeString).format('HH:mm');
            },
        },
    }
</script>

<style scoped>

</style>
